module.exports = __webpack_public_path__ + "static/media/luurtsema center.e4a0ddf6.jpeg";